import React from "react"
import { isMobileOnly } from "react-device-detect"
import clsx from "clsx"

import { useBikeStoreProcess } from "hooks"
import { BackToStoreCard, BackToStoreRequestedCard } from "./BackToStore"
import { BuyCard, BuyRequestedCard } from "./Buy"
import { BACK_PROPERTY_TRANSFER_REQUEST, BUY_PROPERTY_TRANSFER_REQUEST } from "utils/constants"

export const BackAndBuyBike: React.FC = () => {
	const { bikeProcessState } = useBikeStoreProcess()
	const { currentBike: bike } = bikeProcessState

	const isBackToStoreTransferRequested =
		bike?.property_transfer_request?.context === BACK_PROPERTY_TRANSFER_REQUEST
	const isBuyTransferRequested =
		bike?.property_transfer_request?.context === BUY_PROPERTY_TRANSFER_REQUEST

	return (
		<div className={clsx("flex justify-between mb-7", { "flex-col": isMobileOnly })}>
			{!isBackToStoreTransferRequested && !isBuyTransferRequested && (
				<>
					<BackToStoreCard />
					<BuyCard />
				</>
			)}

			{isBackToStoreTransferRequested && <BackToStoreRequestedCard isBO={false} />}

			{isBuyTransferRequested && <BuyRequestedCard isBO={false} />}
		</div>
	)
}
